import {
  COUPON_SEARCH,
  COUPON_RESET_SEARCH,
  COUPON_COUNT_TOTAL,
  COUPON_LIST_FETCH,
  COUPON_LIST_FETCH_SUCCESS,
  COUPON_DETAIL_CLEAR,
  COUPON_DETAIL_FETCH,
  COUPON_DETAIL_FETCH_SUCCESS,
  COUPON_LIST_PROFILE_FETCH,
} from "./types";

export const couponSearch = payload => {
  return {
    type: COUPON_SEARCH,
    payload: payload
  }
}

export const couponResetSearch = ()=>{
  return {
    type: COUPON_RESET_SEARCH
  }
}

export const couponCountTotal = payload => {
  return {
    type: COUPON_COUNT_TOTAL,
    payload: payload
  }
}

export const couponListFetch = (payload = "") => {

    return {
    type: COUPON_LIST_FETCH,
    payload: payload
    };
};

export const couponListProfileFetch = (payload = "") => {
    return {
    type: COUPON_LIST_PROFILE_FETCH,
    payload: payload
    };
};

export const couponListFetchSuccess = payload => {
  return {
    type: COUPON_LIST_FETCH_SUCCESS,
    payload: payload
  };
};

export const couponDetailClear = () => {
    return {
        type : COUPON_DETAIL_CLEAR
    };
}

export const couponDetailFetch = (payload) => {
    return {
        type: COUPON_DETAIL_FETCH,
        payload: payload,
    };
};

export const couponDetailFetchSuccess = ( payload ) => {
    return {
        type: COUPON_DETAIL_FETCH_SUCCESS,
        payload: payload
    };
};
